module.exports = __webpack_public_path__ + "static/img/3.4c2f588.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/eng/3.png
// module id = YTwA
// module chunks = 0